import { useCallback } from 'react';
import { useSnackbarStore } from '../../../shared/stores/useSnackbarStore';
import { useRevitApi } from '../../../shared/api/revit/useRevitApi';
import { highlightElementsGrpc } from '../../../shared/api/grpc/validationGrpcClient';
import { USE_GRPC, USE_MOCK } from '../lib/validationRuntimeEnv';

export interface UseValidationHighlightReturn {
  handleHighlightElements: (elementIds: string[]) => Promise<void>;
}

export function useValidationHighlight(): UseValidationHighlightReturn {
  const { call } = useRevitApi();
  const snackbar = useSnackbarStore();

  const handleHighlightElements = useCallback(
    async (elementIds: string[]) => {
      if (USE_GRPC) {
        try {
          const bigIntIds = elementIds.map((id) => BigInt(id));
          const result = await highlightElementsGrpc(bigIntIds);
          if (result.success) {
            snackbar.showSuccess(`Highlighted ${result.count} element(s) in Revit`);
          } else {
            snackbar.showError(result.error || 'Failed to highlight elements');
          }
        } catch (err: any) {
          snackbar.showError(err.message || 'Failed to highlight elements');
        }
        return;
      }

      if (USE_MOCK) {
        snackbar.showSuccess(`[MOCK] Highlighted ${elementIds.length} element(s)`);
        return;
      }

      try {
        const result = await call('validation.highlightElements', {
          elementIds: JSON.stringify(elementIds),
        });

        if (result.success) {
          snackbar.showSuccess(`Highlighted ${result.count} element(s) in Revit`);
        } else {
          snackbar.showError(result.error || 'Failed to highlight elements');
        }
      } catch (err: any) {
        snackbar.showError(err.Message || 'Failed to highlight elements');
      }
    },
    [call, snackbar]
  );

  return { handleHighlightElements };
}
